module.exports = __webpack_public_path__ + "static/media/topUpRuleSetting.7f6b373c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/feature/dPay/topUpRuleSetting.png
 ** module id = 599
 ** module chunks = 0
 **/